import React, { useContext, useEffect, useState } from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../App.css";
import moment from "moment";

import { makeStyles } from "@material-ui/core/styles";

//import AlertDialog from "../../blocks/AlertDialog";
//import LoadingProgress from "../../blocks/LoadingProgress";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";

import CostingList from "./components/CostingList";
import CostingsStyles from "./styles/CostingsStyles";
import SearchBar from "../../controls/SearchBar";
import SystemContext from "../../SystemContext";
import AirportsLookup from "../Airports/components/AirportsLookup";
import { isBlank } from "../../utils";

const AccessControl = require ("../../AccessControl");

const airportSearch = (search, fieldDef, onChange, recordChange) => {
  return (
    <AirportsLookup
      key={fieldDef.field}
      id={fieldDef.field}
      label={fieldDef.label}
      width={fieldDef.width}
      returnType={"object"}
      value={search[fieldDef.field]}
      inputProps={{...fieldDef.clearSearch}}
      disableClearable={false}
      inputLabelProps={{shrink: fieldDef.shrink||fieldDef.shrinkAll||!isBlank(search[fieldDef.field])}}
      onChange={(returnObject) => {
        if (returnObject){
          if (returnObject.found) {
            onChange(returnObject?.data?.airportCode);
          } else {
            onChange(returnObject?.value);
          }  
        } else {
          onChange("");
        }
      }}
    />
  )
}

function Costings(props) {
  const classes = makeStyles(CostingsStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage COSTINGS"]);

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const handleAddClicked = () => {
    console.debug('Add Clicked');
    eventBus.trigger('CostingList.Add');
  }

  const defaultSearch = {
    costingNumber: null,
    fromDate: moment().startOf('day').subtract(60, 'day').toISOString(),
    toDate: moment().endOf('day').toISOString(),
    origin: "",
    destination: "",
    refresh: 0
  };

  const [searchCriteria, setSearchCriteria] = useState({...defaultSearch});

  const handleSearch = (search, searchRecordChange) => {
    setSearchCriteria(search);
  }

  useEffect(()=> {
    const handleRefreshList = ()=> {
      setSearchCriteria({...searchCriteria, refresh: (searchCriteria?.refresh||0) + 1, toDate: moment().endOf('day').toISOString()});
    }
    if (eventBus) {
      eventBus.bind('CostingList.refresh', handleRefreshList);
    }
    return () => {
      eventBus.unbind('CostingList.refresh', handleRefreshList);
    }
  }, [eventBus, searchCriteria]);

  return (isAuthenticated &&
    <div
      className="Costings"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="costings"
        pageName="Costings"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>
      <SearchBar 
        shrinkAll={false}
        heading="Costing Management"
        alignFields="right"
        // searchButtonStyle={{padding: "20px 5px"}}
        // clearButtonStyle={{padding: "20px 5px"}}
        fields={[
          {field: "costingNumber", type:"number", label: "Costing No.", valueCap: 999999, decimalScale:0, fixedDecimalScale:true, format:"UCN ######", width: 120, defaultValue: defaultSearch.costingNumber},
          {field: "fromDate", type:"date", label: "From Date", defaultValue: defaultSearch.fromDate},
          {field: "toDate", type:"date", label: "To Date", defaultValue: defaultSearch.toDate},
          {field: "origin", type:"text", label: "Origin", defaultValue: defaultSearch.origin, width: 80, render: airportSearch, addWrapper: true},          
          {field: "destination", type:"text", label: "Dest.", defaultValue: defaultSearch.destination, width: 80, render: airportSearch, addWrapper: true},          
        ]}
        searchDisabled={(search) => {
          if (isBlank(search['costingNumber']) && isBlank(search['fromDate']) && isBlank(search['toDate'])) return true;
          return false;
        }}
        actions={[
          {iconName:"add_box", disabled: false, onClick: handleAddClicked, tooltip: "Add"}
        ]}
        eventPrefix="Costing"
        onSearch={handleSearch}
        onResetSearch={handleSearch}
      />
      <div
        className={classes.rooted}
        style={{ marginLeft: 40, marginRight: 40, minHeight: `calc(100vh - ${(99+2+10+57+4+75)}px)`, maxHeight: `calc(100vh - ${(99+2+10+57+4+75)}px)` }}
      >
        <CostingList classes={classes} canEdit={canEdit} searchCriteria={searchCriteria}/>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default Costings;